import axios from "axios";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-Type": "application/json; Charset=utf-8",
    Accept: "*/*",
  },
});

// http.interceptors.response.use(
//   (response) => response,
//   (error) => {
//       if (error.response && error.response.status === 401) {
//           document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
//           window.location.href = "/login";
//       }
//       return Promise.reject(error);
//   }
// );

export default http;
